import React, { useRef } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  ToggleButton,
  ToggleButtonGroup,
  Divider,
  Box,
} from "@mui/material";
import LightModeIcon from "@mui/icons-material/LightMode";
import DarkModeIcon from "@mui/icons-material/DarkMode";
import SettingsBrightnessIcon from "@mui/icons-material/SettingsBrightness";
import DownloadIcon from "@mui/icons-material/Download";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";

export default function SettingsMenu({
  open,
  onClose,
  themeMode,
  setThemeMode,
  exportJSON,
  importJSONFile,
  clearAll,
}) {
  const fileInputRef = useRef(null);

  return (
    <Dialog open={!!open} onClose={onClose} fullWidth maxWidth="xs">
      <DialogTitle>Settings</DialogTitle>
      <DialogContent>
        <Box className="settings-section">
          <Typography variant="subtitle2">Theme</Typography>
          <ToggleButtonGroup
            exclusive
            fullWidth
            size="small"
            value={themeMode}
            onChange={(e, v) => v && setThemeMode(v)}
          >
            <ToggleButton value="light">
              <LightModeIcon fontSize="small" sx={{ mr: 1 }} />
              Light
            </ToggleButton>
            <ToggleButton value="system">
              <SettingsBrightnessIcon fontSize="small" sx={{ mr: 1 }} />
              System
            </ToggleButton>
            <ToggleButton value="dark">
              <DarkModeIcon fontSize="small" sx={{ mr: 1 }} />
              Dark
            </ToggleButton>
          </ToggleButtonGroup>
        </Box>

        <Divider sx={{ my: 2 }} />

        <Box className="settings-section">
          <Typography variant="subtitle2">Data</Typography>
          <Box sx={{ display: "flex", gap: 1, mt: 0.5 }}>
            <Button
              fullWidth
              variant="outlined"
              startIcon={<DownloadIcon />}
              onClick={exportJSON}
            >
              Export
            </Button>
            <Button
              fullWidth
              variant="outlined"
              startIcon={<UploadFileIcon />}
              onClick={() => fileInputRef.current && fileInputRef.current.click()}
            >
              Import
            </Button>
          </Box>
          <input
            ref={fileInputRef}
            type="file"
            accept="application/json"
            className="file-input"
            onChange={(e) => {
              importJSONFile(e.target.files);
              e.target.value = "";
            }}
          />
        </Box>

        <Divider sx={{ my: 2 }} />

        <Box className="settings-section">
          <Typography variant="subtitle2">Danger zone</Typography>
          <Button
            fullWidth
            color="error"
            variant="outlined"
            startIcon={<DeleteOutlineIcon />}
            sx={{ mt: 0.5 }}
            onClick={clearAll}
          >
            Clear all events
          </Button>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Close</Button>
      </DialogActions>
    </Dialog>
  );
}
